import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE } from "../utils/api";

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

const PUBLIC_ROUTES = ["/nyafaz-salon", "/verify", "/nyafaz-salon/set-password"];

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isPublic = PUBLIC_ROUTES.some((route) => {
      if (route === "/nyafaz-salon") {
        return location.pathname === "/nyafaz-salon" || location.pathname === "/nyafaz-salon/";
      }
      return location.pathname.startsWith(route);
    });

    if (isPublic) {
      setLoading(false);
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigate("/nyafaz-salon");
      return;
    }

    setToken(userId);

    fetch(`${API_BASE}/user/${userId}`, {
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch user");
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => navigate("/nyafaz-salon"));
  }, [navigate, location.pathname]);

  return (
    <UserContext.Provider value={{ user, token, loading }}>
      {children}
    </UserContext.Provider>
  );
};
